import React from 'react';
import AllOrders from '../allOrders/AllOrders';

const MerchantAllParcels = () => {
	return <AllOrders admin={false} title='All Parcels' isRejected={false} />;
};

export default MerchantAllParcels;
